import { activate } from './user/activate'

export const users = {
  title: 'Użytkownicy',
  add: 'Dodaj użytkownika',
  default2FATitle: 'Domyślna metoda 2FA',
  add2FA: 'Dodaj',
  delete2Fa: 'Usuń',
  default2FADescription: 'Wybierz domyślną metodę 2FA dla nowych użytkowników',
  defaultMethod: 'Domyślna metoda',
  chosePreferred2FAMethod:
    'Wybierz swoją preferowaną metodę uwierzytelniania dwuskładnikowego (2FA). Możesz zmienić tę opcję w dowolnym momencie.',
  no2FAMethods: 'Nie skonfigurowano żadnej metody podwójnej autoryzacji',
  twoFactorMethods: 'Metody 2FA',
  authenticator: 'Aplikacja autoryzacyjna',
  authenticatorDescription:
    'Aplikacja autoryzacyjna (np. Google Authenticator, Authy)',
  codeSend: 'Kod został wysłany',
  emailDescription: 'Kod zostanie wysłany na Twój adres email',
  configured: 'Skonfigurowano',
  updatedUser: 'Użytkownik został zaktualizowany',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  email: 'Email',
  roles: 'Rola',
  createdUser: 'Użytkownik został stworzony',
  searchTable: 'Wyszukaj',
  showInactive: 'Pokaż nieaktywnych',
  showInactiveOnly: 'Pokaż tylko nieaktywnych',
  addUser: 'Dodaj użytkownika',
  editUser: 'Edycja użykownika',
  statusUser: 'Edycja statusu użytkownika',
  deActivateUser: 'Deaktywuj konto użytkownika',
  activateUser: 'Aktywuj konto użytkownika',
  changedStatus: 'Zmieniono status użytkownika',
  resendMailSuccess: 'Wysłano ponownie mail aktywacyjny',
  roleChoice: 'Wybierz rolę',
  emailConfirmCode: 'Potwierdź kodem z maila',
  passwordConfirm: 'Potwierdź hasłem',
  authenticatorConfirm: 'Potwierdź kodem z aplikacji autoryzacyjnej',
  emailConfirmCodeRequired: 'Podanie kodu z maila jest wymagane',
  passwordConfirmRequired: 'Podanie hasła jest wymagane',
  authenticatorConfirmRequired:
    'Podanie kodu z aplikacji autoryzacyjnej jest wymagane',
  tooltips: {
    edit: 'Edytuj użytkownika',
    resendMail: 'Wyślij ponownie mail',
    delete: 'Usuń użytkownika',
  },
  delete: {
    deleteUser: 'Usuwanie użytkownika',
    deleteUserConfirm: 'Czy na pewno chcesz usunąć użytkownika',
    deletedUserSuccess: 'Użytkownik został usunięty',
  },
  disabledEditBaseRole: 'Roli bazowej nie można edytować ani usuwać.',
  activate: activate,
  confirmEmailChange: {
    loading: 'Trwa potwierdzanie zmiany adresu e-mail',
    success: 'Adres e-mail został zmieniony. Zaloguj się ponownie.',
    invalidOrExpired:
      'Link wygasł lub jest nieprawidłowy. Poproś o ponowną zmianę adresu.',
    emailAlreadyTaken: 'Ten adres e-mail jest już zajęty.',
    missingParams: 'Błędny link',
    goToLogin: 'Przejdź do logowania',
  },
  pendingEmailChange: {
    badge: 'Oczekuje zmiana',
    message: 'Zmiana na {email} czeka na potwierdzenie',
    created:
      'Na adres {email} wysłaliśmy link potwierdzający. Zmiana zacznie obowiązywać po jego kliknięciu (link jest ważny do {expiresAt}).',
    cancelled: 'Oczekująca zmiana adresu e-mail została anulowana.',
    cancelAction: 'Anuluj zmianę',
  },
}
